// Tiny Web Audio synth for rally cues. No asset files — just oscillator
// arpeggios. AudioContext is lazily created (browser policy: needs a user
// gesture before sound plays; opening the rally view counts).

let ctx = null;
let muted = false;

function getCtx() {
  if (!ctx) {
    try {
      const AC = window.AudioContext || window.webkitAudioContext;
      ctx = AC ? new AC() : null;
    } catch { ctx = null; }
  }
  if (ctx && ctx.state === 'suspended') {
    try { ctx.resume(); } catch { /* ignore */ }
  }
  return ctx;
}

function playSequence(notes) {
  if (muted) return;
  const c = getCtx();
  if (!c) return;
  let t = c.currentTime;
  notes.forEach(({ freq, dur, type = 'sine', vol = 0.22 }) => {
    const osc = c.createOscillator();
    const g = c.createGain();
    osc.type = type;
    osc.frequency.setValueAtTime(freq, t);
    g.gain.setValueAtTime(0, t);
    g.gain.linearRampToValueAtTime(vol, t + 0.005);
    g.gain.exponentialRampToValueAtTime(0.001, t + dur);
    osc.connect(g).connect(c.destination);
    osc.start(t);
    osc.stop(t + dur + 0.05);
    t += dur;
  });
}

// Soft two-tone "ka-ching" — fired on every successful checkpoint claim.
export function playCheckpointChime() {
  playSequence([
    { freq: 783.99, dur: 0.10 }, // G5
    { freq: 1046.50, dur: 0.22 }, // C6
  ]);
}

// Bigger reveal fanfare — fires when the slot machine lands on a positive
// or attack bonus.
export function playBonusFanfare() {
  playSequence([
    { freq: 523.25, dur: 0.07 }, // C5
    { freq: 659.25, dur: 0.07 }, // E5
    { freq: 783.99, dur: 0.07 }, // G5
    { freq: 1046.50, dur: 0.30 }, // C6 — held
  ]);
}

// "no_effect" landed: a small descending blip, less punching-down than a sad alert.
export function playNoEffectBlip() {
  playSequence([
    { freq: 587.33, dur: 0.10, type: 'triangle', vol: 0.15 }, // D5
    { freq: 415.30, dur: 0.18, type: 'triangle', vol: 0.15 }, // G#4
  ]);
}

// Played when the driver is HIT by an attack from another driver.
export function playSadAlert() {
  playSequence([
    { freq: 369.99, dur: 0.18, type: 'square', vol: 0.18 }, // F#4
    { freq: 311.13, dur: 0.18, type: 'square', vol: 0.18 }, // D#4
    { freq: 261.63, dur: 0.32, type: 'square', vol: 0.18 }, // C4
  ]);
}

// Quick "lock-on" tick during slot deceleration.
export function playSlotTick() {
  playSequence([
    { freq: 880, dur: 0.04, type: 'square', vol: 0.06 },
  ]);
}

export function setRallySoundsMuted(value) { muted = !!value; }
export function isRallySoundsMuted() { return muted; }
